import { NavLink } from 'react-router-dom'
import { NAV_ITEMS } from './navItems'
import styles from './NavBar.module.css'

/**
 * Persistent primary navigation. The same items render as a top bar on wider
 * screens and as a bottom tab bar on narrow screens; CSS shows exactly one at
 * each breakpoint (the hidden one is `display: none`, so it leaves the
 * accessibility tree and there is only ever one nav landmark exposed).
 */
export function NavBar() {
  return (
    <>
      <header className={styles.topBar}>
        <div className={styles.topInner}>
          <span className={styles.brand}>Daily Learning</span>
          <nav aria-label="Primary">
            <ul className={styles.topList}>
              {NAV_ITEMS.map((item) => (
                <li key={item.to}>
                  <NavLink to={item.to} className={linkClass}>
                    {item.label}
                  </NavLink>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </header>

      <nav className={styles.bottomBar} aria-label="Primary">
        <ul className={styles.bottomList}>
          {NAV_ITEMS.map((item) => (
            <li key={item.to}>
              <NavLink to={item.to} className={tabClass}>
                <span className={styles.tabIcon}>{item.icon}</span>
                <span className={styles.tabLabel}>{item.label}</span>
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </>
  )
}

function linkClass({ isActive }: { isActive: boolean }) {
  return isActive ? `${styles.link} ${styles.linkActive}` : styles.link
}

function tabClass({ isActive }: { isActive: boolean }) {
  return isActive ? `${styles.tab} ${styles.tabActive}` : styles.tab
}
